'use strict';

export default {
  formSettings: {
    formInput: {
      settingsHeading: 'Form Properties',
      placeholder: 'New Name',
      formName: 'Form Name',
      startDate: 'Start Date',
      endDate: 'End Date',
      limit: 'Form Limit',
      captchaEnabled: 'Recaptcha Enabled',
      enablePayment: 'Enable Payment',
      paymentAccount: 'Payment Account',
      enableOtherPayment: 'Allow other payment types',
      fixedAmountLabel: 'Form fixed amount',
      fixedAmount: 'XX.XX $',
      administratorsEmails: 'Administrators Emails',
      emailContent: 'Email Content',
    },
    errorMessage: {
      short: 'Minimum length is 4 characters',
      long: 'Too Long',
      required: "Can't be empty",
      email: 'Must be valid email',
    },
  },
};
